module.exports = __webpack_public_path__ + "static/media/gift-ticket.c88ec980.png";